var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.5C16.9706 21.5 21 17.4706 21 12.5C21 7.52944 16.9706 3.5 12 3.5C7.02944 3.5 3 7.52944 3 12.5C3 17.4706 7.02944 21.5 12 21.5ZM16.7682 10.1402C17.1218 9.71591 17.0645 9.08534 16.6402 8.73178C16.2159 8.37821 15.5853 8.43554 15.2318 8.85982L11.6338 13.1774C11.2871 13.5934 11.0922 13.8238 10.9366 13.9653L10.9306 13.9707L10.9242 13.9659C10.7564 13.839 10.5415 13.6272 10.1585 13.2443L8.70711 11.7929C8.31658 11.4024 7.68342 11.4024 7.29289 11.7929C6.90237 12.1834 6.90237 12.8166 7.29289 13.2071L8.74428 14.6585L8.78511 14.6993L8.78512 14.6993C9.11161 15.026 9.4257 15.3402 9.71794 15.5611C10.0453 15.8087 10.474 16.0415 11.0234 16.0165C11.5728 15.9916 11.9787 15.721 12.2823 15.4448C12.5534 15.1983 12.8377 14.8569 13.1333 14.5021L13.1333 14.5021L13.1703 14.4577L16.7682 10.1402Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckedCircle);
export default __webpack_public_path__ + "static/media/icon_checked_circle.669c3b597b021fe0f0327ad6d8f0333b.svg";
export { ForwardRef as ReactComponent };